import { render, staticRenderFns } from "./EnrollmentForm.vue?vue&type=template&id=5fa2a17e&scoped=true"
import script from "./EnrollmentForm.vue?vue&type=script&lang=js"
export * from "./EnrollmentForm.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentForm.vue?vue&type=style&index=0&id=5fa2a17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2a17e",
  null
  
)

export default component.exports